import React from "react";
import HeroSectionNew from "../../Components/LandingNew/HeroSectionNew";
import SoulFlowSectionNew from "../../Components/LandingNew/SoulFlowSectionNew";
import MystioSectionNew from "../../Components/LandingNew/MystioSectionNew";
import DigitalLibrarySectionNew from "../../Components/LandingNew/DigitalLibrarySectionNew";
import OverviewSectionNew from "../../Components/LandingNew/OverviewSectionNew";
import AdsStreamSectionNew from "../../Components/LandingNew/AdsStreamSectionNew";
import NotificationBannerNew from "../../Components/LandingNew/NotificationBannerNew";
import FooterNew from "../../Components/LandingNew/FooterNew";
import useLandingNew from "./useLandingNew";

// Easy configuration for custom background image. 
// If they provide an image path or import, it will apply inline, overriding the default gradient nebula background.
const CUSTOM_BACKGROUND_IMAGE = null;

export default function LandingNew() {
  const { onCategorySelect } = useLandingNew();

  const backgroundStyle = CUSTOM_BACKGROUND_IMAGE
    ? {
      backgroundImage: `url(${CUSTOM_BACKGROUND_IMAGE})`,
      backgroundSize: "cover",
      backgroundAttachment: "fixed",
      backgroundPosition: "center",
    }
    : {};

  return (
    <div
      className={`min-h-screen bg-black text-white ${!CUSTOM_BACKGROUND_IMAGE ? "bab-new-bg" : ""}`}
      style={backgroundStyle}
    >
      {/* Hero Header Section */}
      <HeroSectionNew onCategorySelect={onCategorySelect} />

      {/* SoulFlow Records Section */}
      <SoulFlowSectionNew />

      {/* Mystio Global Logistics Section */}
      <MystioSectionNew />

      {/* Digital Library Section */}
      <DigitalLibrarySectionNew />

      {/* Overview Accordion Section */}
      <OverviewSectionNew />

      {/* Continuous Ads Stream Section */}
      <AdsStreamSectionNew />

      {/* Bottom Blue Notification Banner */}
      <NotificationBannerNew />

      {/* Footer */}
      <FooterNew />
    </div>
  );
}
